import React from "react";
import { Link } from "react-router-dom";

function Navbar() {
  return (
    <nav
      style={{
        padding: "15px 20px",
        backgroundColor: "#e3f2fd",
        borderBottom: "1px solid #ccc",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Link
        to="/"
        style={{
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
        }}
      >
        <img
          src="/SYK_logo.png"
          alt="Share Your Kofi logo"
          style={{ height: "36px", marginRight: "10px" }}
        />
        <h1 style={{ fontSize: "1.5rem", color: "#333", margin: 0 }}>
          Share Your Kofi
        </h1>
      </Link>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          justifyContent: "center", // Center links on mobile
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <Link to="/" style={navLinkStyle}>
          Home
        </Link>
        <Link to="/creators" style={navLinkStyle}>
          All Creators
        </Link>
        <Link to="/recommended" style={navLinkStyle}>
          All Recommended
        </Link>
        <Link to="/submit" style={actionLinkStyle}>
          Submit
        </Link>
        <Link to="/recommend" style={actionLinkStyle}>
          Recommend
        </Link>
        <Link to="/about" style={navLinkStyle}>
          About
        </Link>
      </div>
    </nav>
  );
}

const navLinkStyle = {
  textDecoration: "none",
  backgroundColor: "#4dabf7",
  color: "#fff",
  padding: "8px 14px",
  borderRadius: "20px",
  fontSize: "0.95rem",
  fontWeight: "bold",
  transition: "background 0.2s",
};

const actionLinkStyle = {
  ...navLinkStyle,
  backgroundColor: "#FF6961", // Submit & Recommend button colors
};

export default Navbar;
